import { Colors } from '@oy/uicore';
import {
  Button,
  IconButton,
  IconButtonSize,
  IconButtonType,
  Modal,
  Text,
} from '@oy/uidesktop';
import classNames from 'classnames';
import React, { useState } from 'react';
import { getTranslation } from 'src/utilities/translator';
import styles from './Column.module.css';

type ColumnProps = {
  borderRight?: boolean;
  className?: string;
  content: React.ReactNode;
  contentAlignment?: 'center' | 'top';
  title?: string | React.ReactNode;
  tooltip?: boolean;
  tooltipHeader?: string;
  tooltipContent?: React.ReactNode;
};

const Column = ({
  borderRight = false,
  className,
  content,
  contentAlignment = 'center',
  title,
  tooltip,
  tooltipHeader,
  tooltipContent,
}: ColumnProps) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const containerClass = classNames(styles.container, className, {
    [styles.borderRight]: borderRight,
  });

  const contentContainerClass = classNames(
    styles.contentContainer,
    styles[contentAlignment],
  );

  return (
    <div className={containerClass}>
      {title && (
        <div className={tooltip ? styles.tooltip : ''}>
          <Text color={Colors.BLACK40} textStyle={Text.Style.BodySmSemibold}>
            {title}
          </Text>
          {tooltip && (
            <IconButton
              iconName="information"
              buttonType={IconButtonType.Clear}
              color="secondary"
              size={IconButtonSize.Medium}
              onClick={() => setShowTooltip(!showTooltip)}
            />
          )}
        </div>
      )}
      <div className={contentContainerClass}>{content}</div>
      <Modal show={showTooltip} style={{ maxWidth: 480 }}>
        <Modal.Header>{tooltipHeader}</Modal.Header>
        <Modal.Body>{tooltipContent}</Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setShowTooltip(false)} fullWidth>
            {getTranslation('common_understand')}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Column;
